import portalApi from "../api/apiSlice";

const assignmentsMarkApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMarks: builder.query({
      query: () => "assignmentMark",
    }),
    getSignleAssignmentMark: builder.query({
      query: (data) =>
        `assignmentMark?student_id=${data.student_id}&assignment_id=${data.assignment_id}`,
    }),
    addAssignmentMark: builder.mutation({
      query: (newAssignmentMark) => ({
        url: "assignmentMark",
        method: "POST",
        body: newAssignmentMark,
      }),

      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        let updateGetAssignmentMarks;

        try {
          const { data } = await queryFulfilled;
          updateGetAssignmentMarks = dispatch(
            portalApi.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                draft.push(data);
              }
            )
          );
        } catch (error) {
          updateGetAssignmentMarks.undo();
        }
      },
    }),

    updateAssignmentMark: builder.mutation({
      query: (assignmentMark) => ({
        url: `assignmentMark/${assignmentMark.id}`,
        method: "PUT",
        body: assignmentMark,
      }),

      onQueryStarted: async (assignmentMark, { dispatch, queryFulfilled }) => {
        let updateAssignmentMark;

        try {
          await queryFulfilled;
          updateAssignmentMark = dispatch(
            portalApi.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (prevAssignmentMarks) => {
                return prevAssignmentMarks.map((prevAssignmentMark) => {
                  if (prevAssignmentMark.id === assignmentMark.id) {
                    return assignmentMark;
                  }

                  return prevAssignmentMark;
                });
              }
            )
          );
        } catch (error) {
          updateAssignmentMark.undo();
        }
      },
    }),
  }),
});

export const {
  useGetAssignmentMarksQuery,
  useGetSignleAssignmentMarkQuery,
  useAddAssignmentMarkMutation,
  useUpdateAssignmentMarkMutation,
} = assignmentsMarkApi;
